<template>
  <b-container class="mb-3 card-custom-class w-100">
    <b-row v-if="$store.state['checkout'].couponLoading">
      <b-col>
        <b-skeleton class="mb-2" animation="wave" width="85%"></b-skeleton>
        <b-skeleton class="mb-2" animation="wave" width="55%"></b-skeleton>
        <b-skeleton animation="wave" width="70%"></b-skeleton>
      </b-col>
    </b-row>
    <b-row v-else align-v="center">
      <b-col md="3">
        <b-input-group>
          <label for="coupon-input" class="coupon-label mb-0">{{
            $t("couponCode")
          }}</label>
        </b-input-group>
      </b-col>
      <b-col md="9" class="">
        <div class="couponMainSec">
          <b-form-input
            class="coupon-input"
            :placeholder="$t('enterCode')"
            disabled
          />
          <!-- <b-form-input
            class="coupon-input"
            placeholder="Enter code"
            :value="selectedCoupon.promoCode"
            disabled
          /> -->
          <b-button
            class="apply-button"
            variant="primary"
            @click="$bvModal.show('bv-modal-coupon')"
          >
            {{ $t("applyCode") }}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="bv-modal-coupon"
      size="lg"
      :hide-footer="true"
      :hide-header="true"
      :no-close-on-esc="false"
      :no-close-on-backdrop="true"
      centered
    >
      <b-card class="card-custom-class">
        <div class="closemodel">
          <b-button
            variant="link"
            @click="$bvModal.hide('bv-modal-coupon')"
            class="p-0"
          >
            <b-icon icon="x-circle" scale="1.5" variant="danger"></b-icon>
          </b-button>
        </div>
        <span class="change-location-text">{{ $t("selectCoupon") }}</span>
      </b-card>
      <b-list-group class="list-group-modal">
        <b-card
          body-class="body-class-modal"
          v-for="(coupon, index) in couponList"
          :key="index"
          class="card-custom-class"
        >
          <b-row>
            <b-col md="6">
              <b-card-text>
                <b-form-radio
                  @change="changeRadio(coupon)"
                  :value="coupon.promoCode"
                  name="radio-size"
                  v-model="currentCoupon.promoCode"
                  size="lg"
                >
                  <span class="address-name">{{ coupon.title }}</span>
                </b-form-radio>
              </b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-card-text class="address-details-text">
                {{ coupon.description }}
              </b-card-text>
            </b-col>
          </b-row>
        </b-card>
      </b-list-group>
    </b-modal>
  </b-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    callApi: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      selectedCoupon: (state) => state.checkout.selectedCoupon,
      couponList: (state) => state.checkout.couponList,
    }),
    currentCoupon() {
      let obj = {};
      if (Object.keys(this.selectedCoupon).length)
        obj = { ...this.selectedCoupon };
      return obj;
    },
  },
  methods: {
    changeRadio(e) {
      console.log(e, "e");
      // this.$store.commit('checkout/updateselectedCoupon', e);
      this.$store.dispatch("checkout/selectCoupon", e);
      this.$bvModal.hide("bv-modal-coupon");
    },
  },
  async mounted() {
    if (this.callApi) await this.$store.dispatch("checkout/fetchCouponList");
  },
};
</script>

<style scoped>
.coupon-label {
  font-size: 1.25rem;
  font-weight: 500;
}
.card-custom-class {
  top: 20px !important;
  border: none;
  background-color: #fff;
  /* padding: 1rem; */
  border-radius: 8px;
  border: 1px solid #e5e5e5;
}

.coupon-input:disabled {
  background-color: transparent;
}

.couponMainSec {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 50px; /* Rounded edges */
  overflow: hidden;
}
.coupon-input {
  flex: 1;
  border: none;
  padding: 10px 15px;
  border-radius: 50px 0 0 50px; /* Rounded left side */
  outline: none;
  font-size: 16px;
}
.apply-button {
  border-radius: 50px; /* Rounded button */
  padding: 10px 20px;
  font-size: 16px;
  background: #333; /* Dark background */
  border: none;
  color: #fff;
}
.apply-button:hover {
  background-color: #0056b3;
  color: white;
}
.b-skeleton {
  background-color: #f1f3f5 !important;
  border-radius: 4px;
}
.list-group-modal {
  max-height: 340px;
  overflow-y: auto;
}
.change-location-text {
  font-size: 18px;
  font-weight: 500;
  color: #2e2e2e;
  text-align: center;
  margin-bottom: 8px;
}
.address-name {
  font-size: 16px;
  font-weight: 500;
  color: #000;
}
.address-details-text {
  font-size: 14px;
  font-weight: 400;
  color: #555;
  margin-left: 8px;
}
</style>
